import {
  Checkbox as MuiCheckbox,
  FormControl,
  FormControlLabel,
  FormLabel,
} from "@material-ui/core";
import { compose } from "ramda";
import { memo, useState } from "react";
import { UseFormMethods } from "react-hook-form";

import { withError } from "../HOC";
import { CommonFormElProps } from "../types";

type CheckboxItem = {
  readonly label: string | JSX.Element;
  readonly value: string;
};

export type CheckboxProps = {
  readonly items: Array<CheckboxItem>;
  readonly register: UseFormMethods["register"];
} & CommonFormElProps;

export const Checkbox = memo<CheckboxProps>(
  ({
    defaultValue,
    id,
    items,
    label,
    onChange: onChangeAction,
    register,
    required = false,
  }) => {
    const [value, setValue] = useState(defaultValue);

    return (
      <FormControl fullWidth component="fieldset">
        {label && (
          <FormLabel component="legend" required={required}>
            {label}
          </FormLabel>
        )}
        {items.map(({ label, value: itemValue }) => (
          <FormControlLabel
            checked={value === itemValue}
            key={[id, itemValue].join("-")}
            control={
              <MuiCheckbox
                name={id}
                key={[id, itemValue].join("-")}
                color="secondary"
                value={itemValue}
                inputRef={register}
                required={required}
                onChange={({ target: { checked, value } }) => {
                  const newValue = checked ? value : "";
                  onChangeAction(newValue);
                  setValue(newValue);
                }}
              />
            }
            label={label}
            value={itemValue}
          />
        ))}
      </FormControl>
    );
  }
);

export const CheckboxWithError = compose(withError)(Checkbox);
